/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";

import styles from "./Header.module.scss";
// SA-585 update logo: start
import LogoLarge from "assets/starbreeze/images/Nebula.svg";
// SA-585 update logo: end
// SA-61 - Implement zendesk support
import Customize from "assets/starbreeze/images/customize.svg";
import { uiEvents } from "../../../app-message/events/uiEvents";
import { SvgInline } from "../_common/SVGInline";
import { Trans } from "react-i18next";


export default class Header extends React.Component {
  onDrawerClick = () => {
    uiEvents.onNavigationDrawerMenuClick(true);
  }

  render() {
    return (
      <div className={styles.headerBar}>
        <div className={styles.hamburgerMenu} onClick={this.onDrawerClick}>
          <SvgInline url={Customize} className={styles.burgerMenu} />
        </div>
        <div className={styles.logo}>
          <img alt="logo" src={LogoLarge} />
        </div>
        <div className={styles.faqNv}>
          <a href="/events">
            <Trans i18nKey={"Starbreeze.events.navigation.text"}>Events</Trans>
          </a>
          <a href="/support">
            <Trans i18nKey={"Starbreeze.faq.navigation.text"}>Legal</Trans>
          </a>
        </div>
      </div>
    );
  }
}
